import React, { useEffect, useState } from "react";
import { Box, Button, Heading, Image, ResponsiveContext, Spinner, Text, Anchor, Grid } from "grommet";
import { CaretLeftFill, Home, Like, LikeFill, Location, Trophy } from "grommet-icons";
import axios from "axios";
import { Attendee, useUser } from "../utils/AccountStore";
import { Schedule } from "./Schedule";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";

export const GetSchedule = async (id: string) => {
    return axios.get(`${Server}/api/schedules/${id}`);
};

const isEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

const ScheduleDetails = () => {
    const { id } = useParams();
    const [schedule, setSchedule] = useState({} as Schedule);
    const { user, getUser } = useUser();
    const [isFavorite, setIsFavorite] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            GetSchedule(id)
                .then((res) => {
                    if (res.status === 200) {
                        setSchedule(res.data);
                    } else {
                        alert("Error getting schedule");
                        navigate("home");
                    }
                })
                .catch(() => {
                    alert("Error getting schedule");
                    navigate("home");
                });
        }
    }, [id]);

    useEffect(() => {
        if (user.id) {
            setIsFavorite(user.favorites.includes(schedule.id));
        }
    }, [user, schedule]);

    const toggleFavorite = async () => {
        await axios.post(`${Server}/api/attendees/toggleMySchedule`, {
            userID: user.id,
            scheduleID: schedule.id,
        });
        getUser();
    };

    return (
        <ResponsiveContext.Consumer>
            {(size) => (
                <Box pad="medium" align="center" width="100%">
                    {!schedule.id ? (
                        <Spinner />
                    ) : (
                        <Box width="xlarge" gap="medium">
                            <Grid columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                                <CaretLeftFill color="brand" onClick={() => navigate("/schedule")} />
                                <Heading level="2" color="brand">
                                    {format(new Date(schedule.time), schedule.allDay ? "EEEE" : "EEEE HH:mm")}
                                </Heading>
                                <Box direction="row" gap="small" align="center" justify="end">
                                    <Button icon={user.mySchedule?.includes(schedule.id) ? <LikeFill color="white" /> : <Like color="white" />} onClick={toggleFavorite} />
                                </Box>
                            </Grid>

                            <Box>
                                <Text>{schedule.title}</Text>
                            </Box>

                            {schedule.location && (
                                <Box direction="row" align="center" gap="small">
                                    <Location />
                                    <Text weight="bold" color="white">
                                        {schedule.location}
                                    </Text>
                                </Box>
                            )}
                            {schedule.description && (
                                <Box>
                                    <Text>{schedule.description}</Text>
                                </Box>
                            )}
                            {schedule.speaker && <Box>{isEmail(schedule.speaker) ? <Anchor href={`mailto:${schedule.speaker}`} label={schedule.speaker} color={"brand"} /> : <Text>{schedule.speaker}</Text>}</Box>}
                        </Box>
                    )}
                </Box>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default ScheduleDetails;
